import styles from "./UpdateBanner.module.scss";
import { h } from '../utils/jsx-to-html';
import warningIconSrc from '../assets/icons/warning.svg';
import reloadIconSrc from '../assets/icons/reload.svg';
import { classNames } from '../utils/classNames';

export type UpdateBannerContent = {
    title: string;
    description: string;
    additionalDescription?: string;
}

export type UpdateBannerProps = {
    isRendered: boolean;
    messages: UpdateBannerContent;
    timeLeftInSeconds: number;
    onReload: () => void;
}

const SECONDS_IN_MINUTE = 60;

export const UpdateBanner = ({
    isRendered,
    messages,
    timeLeftInSeconds,
    onReload
}: UpdateBannerProps) => {
    return (
        <div 
            className={classNames(
                styles.banner,
                isRendered && styles.isRendered
            )}
            id="update-banner"
            role="alert"
        >
            <UpdateIcon />
            <UpdateContent
                title={messages.title}
                description={messages.description}
                additionalDescription={messages.additionalDescription}
                timeLeftInSeconds={timeLeftInSeconds}
            />
            <div className={styles.spacer} />
            <ReloadButton onClick={onReload} />
        </div>
    );
};

const UpdateIcon = () => (
    <div className={styles.icon}>
        <img src={warningIconSrc} alt="Warning" />
    </div>
);

const UpdateContent = ({ 
    title, 
    description, 
    additionalDescription, 
    timeLeftInSeconds 
}: {
    title: string;
    description: string;
    additionalDescription?: string;
    timeLeftInSeconds: number;
}) => {
    const formattedDescription = additionalDescription?.replace(
        '{timeLeft}', 
        formattedTimeLeft(timeLeftInSeconds)
    );

    return (
        <div className={styles.content}>
            <div className={styles.title}>
                {title}
            </div>
            <div className={styles.description}>
                {description}
                {formattedDescription && (
                    <span>
                        <br />
                        <span className={styles.subDescription}>
                            {formattedDescription}
                        </span>
                    </span>
                )}
            </div>
        </div>
    );
};

const ReloadButton = ({ onClick }: { onClick: () => void }) => (
    <div className={styles.actions}>
        <button 
            className={styles.button}
            onClick={onClick}
            aria-label="Reload page"
        >
            <img src={reloadIconSrc} alt="" />
        </button>
    </div>
);

const formattedTimeLeft = (timeLeftInSeconds: number) => {
    const isRemainingTimeLessThanOneMinute = timeLeftInSeconds < SECONDS_IN_MINUTE;
    const timeLeftInMinutes = Math.round(timeLeftInSeconds / SECONDS_IN_MINUTE);

    return isRemainingTimeLessThanOneMinute ? `${timeLeftInSeconds} сек` : `${timeLeftInMinutes} мин`;
}


